import React from "react";

interface ToggleProps {
  toggled: boolean;
  changeToggle: () => void;
  label?: React.ReactNode;
  disabled?: boolean;
  color?: "blue" | "green";
}

export function Toggle({ toggled, changeToggle, label, disabled = false, color = "blue" }: ToggleProps) {
  const trackBg = toggled
    ? color === "green" ? "bg-green-500" : "bg-cornflower-blue-500"
    : "bg-gray-300";

  return (
    <div className="flex gap-2 items-center">
      <button
        type="button"
        role="switch"
        aria-checked={toggled}
        onClick={disabled ? undefined : changeToggle}
        disabled={disabled}
        className={`relative inline-flex shrink-0 w-10 h-5 rounded-full overflow-hidden transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-cornflower-blue-300 ${trackBg} ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
      >
        <span
          className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow-sm transition-transform duration-200 ease-in-out ${toggled ? "translate-x-5" : "translate-x-0.5"}`}
        />
      </button>
      {label && (
        <label
          onClick={disabled ? undefined : changeToggle}
          className={`cursor-pointer select-none text-sm ${toggled ? "text-blue-600" : "text-slate-500"}`}
        >
          {label}
        </label>
      )}
    </div>
  );
}
